import script from "./SideMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SideMenu.vue?vue&type=script&setup=true&lang=js"

import "./SideMenu.vue?vue&type=style&index=0&id=60f8253f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60f8253f"]])

export default __exports__